import { render, staticRenderFns } from "./Abnormaltail.vue?vue&type=template&id=359193e3&scoped=true&"
import script from "./Abnormaltail.vue?vue&type=script&lang=js&"
export * from "./Abnormaltail.vue?vue&type=script&lang=js&"
import style0 from "./Abnormaltail.vue?vue&type=style&index=0&id=359193e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359193e3",
  null
  
)

export default component.exports